<template>
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <div>
      <div>
        <h1>
          <center>
            <img :src="require('@/assets/image/main-logo.png')" width="70%" />
          </center>
        </h1>
      </div>
      <h3>Recuperar senha</h3>

      <form class="m-t" role="form" @submit.prevent="doRecoverPassword()">
        <div class="form-group">
          <input
            v-model="user.email"
            type="email"
            :disabled="isLoading"
            class="form-control"
            placeholder="E-mail"
            required
          />
        </div>

        <button :disabled="isLoading" type="submit" class="btn btn-primary block full-width m-b">{{ isLoading ? 'Processando...' : 'Recuperar' }}</button>

        <router-link to="/signin">
          <small>Fazer login</small>
        </router-link> 

      </form>
      <p class="m-t">
        <small>RoboMarket &copy; {{curYear}}</small>
      </p>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
export default {
    computed:{
        curYear: function() {
            return new Date().getFullYear();
        }
    },
  methods: {
      doRecoverPassword() {
          this.$data.isLoading = true;
          firebase
            .auth()
            .sendPasswordResetEmail(this.$data.user.email)
            .then(() => {
                alert('E-mail de confirmação enviado para ' + this.$data.user.email);
                this.$data.isLoading = false;
                this.$data.user.email = '';
            }).catch(err => {
                if(err.code === 'auth/user-not-found') {
                    alert('Usuário não encontrado');
                }else {
                    alert('Erro ao enviar o e-mail');
                }
                this.$data.isLoading = false;
            });
      },
    doLogin() {
      this.$data.isLoading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(
          this.$data.user.email,
          this.$data.user.password
        )
        .then(() => {
            this.$router.replace('/admin/inicio');
        })
        .catch((err) => {
          this.$data.isLoading = false;
          switch (err.code) {
            case "auth/user-not-found":
            case "auth/wrong-password":
              alert(
                "Não foi possível efetuar o login. Verifique se informou corretamente as credenciais."
              );
              break;
            default:
              alert(
                "Não foi possível efetuar o login. Verifique se informou corretamente as credenciais. Se esse erro permitir entre em contato conosco."
              );
          }
        });
    },
  },
  data() {
    return {
      isLoading: false,
      user: {
        email: "",
        password: "",
      },
    };
  },
  beforeCreate() {
    if (!document.body.classList.contains("gray-bg"))
      document.body.classList.add("gray-bg");
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../assets/admin/css/bootstrap.min.css";
@import "../../assets/admin/font-awesome/css/font-awesome.css";
@import "../../assets/admin/css/animate.css";
@import "../../assets/admin/css/style.css";
</style>